import { CampusResourceUrls } from 'services/api/models/school/school-details.model';

export interface CampusResource {
  id: string;

  icon: string;
  label: string;
  href?: string;
}

export const DEFAULT_CAMPUS_RESOURCES: CampusResource[] = [
  { id: 'counseling', icon: 'cognition', label: 'Counseling services' },
  { id: 'scholarships', icon: 'payments', label: 'Scholarships' },
  { id: 'career', icon: 'work', label: 'Career services' },
  { id: 'student-success', icon: 'diversity_3', label: 'Student success' },
  { id: 'health', icon: 'health_and_safety', label: 'Health center' },
];

// Maps each fixed dashboard row to the CampusResourceUrls config key.
// Order + labels here are the single source of truth for the master editor
// and the dashboard widget.
export const CAMPUS_RESOURCE_FIELDS: Array<{
  id: string;
  key: keyof CampusResourceUrls;
  label: string;
}> = [
  { id: 'counseling', key: 'counseling', label: 'Counseling services' },
  { id: 'scholarships', key: 'scholarships', label: 'Scholarships' },
  { id: 'career', key: 'career', label: 'Career services' },
  { id: 'student-success', key: 'studentSuccess', label: 'Student success' },
  { id: 'health', key: 'health', label: 'Health center' },
];

